import SlideContent from 'hb-builder/components/BuilderComponents/block/HeroSlider/components/Slide/Settings';
import AddSlideButton from 'hb-builder/components/BuilderComponents/block/HeroSlider/Settings/Content/AddSlideButton';
import DragAndDropList from 'hb-builder/components/common/DragAndDropList';
import { useColorPickerContext } from 'hb-builder/hooks';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { HeroSliderItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/heroSliderItemAttributes';

const Content = ({
  item: heroSlider,
  onChange,
  permissions: { flags } = { can: {}, flags: {} },
}: ComponentSettingsTab<HeroSliderItemAttributes>) => {
  const { resetAllColorPickers } = useColorPickerContext();

  return (
    /* @ts-expect-error not typed */
    <DragAndDropList
      listButton={<AddSlideButton item={heroSlider} />}
      childrenComponent={SlideContent}
      componentName="Slide"
      flags={flags}
      item={heroSlider}
      onChange={onChange}
      onToggleCallback={resetAllColorPickers}
    />
  );
};

export default Content;
